import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

function LegalPage({ ns }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const p = `legal.${ns}`;

  const sections = ns === "mentions"
    ? ["editor", "contact", "hosting", "director", "ip", "data", "cookies"]
    : ["intro", "account", "listing", "price", "shipping", "withdrawal", "liability", "law"];

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12 fade-in">
      <button
        onClick={() => navigate(-1)}
        data-testid="legal-back"
        className="text-sm text-muted-foreground hover:text-foreground mb-8"
      >
        {t("legal.back")}
      </button>

      <h1 className="font-display text-4xl sm:text-5xl leading-tight" data-testid="legal-title">
        {t(`${p}.title`)}
      </h1>
      <p className="mt-2 text-sm text-muted-foreground">{t(`${p}.updated`)}</p>

      <div className="mt-10 space-y-8">
        {sections.map((s) => (
          <section key={s}>
            <h2 className="font-display text-xl sm:text-2xl text-foreground">{t(`${p}.${s}_title`)}</h2>
            <p className="mt-3 text-[15px] leading-relaxed text-muted-foreground whitespace-pre-line">
              {t(`${p}.${s}_body`)}
            </p>
          </section>
        ))}
      </div>

      <div className="mt-16 pt-8 border-t border-border text-sm text-muted-foreground">
        <Link to="/" className="hover:text-primary">VintedStyle.be</Link>
        {" · "}
        <a href="mailto:support.clients@vintedstyle.be" className="hover:text-primary">
          support.clients@vintedstyle.be
        </a>
      </div>
    </div>
  );
}

export function MentionsLegales() { return <LegalPage ns="mentions" />; }
export function CGV() { return <LegalPage ns="cgv" />; }
